import styled, { css } from 'styled-components';
import { isMobile, isTablet } from 'react-device-detect';
import theme from 'shared/assets/style/theme';
import { pwaStyleAdapter } from '../../utils/mobileSupported';

export const TrackingURLContainer = styled.div`
  &::-webkit-scrollbar {
    display: none;
  }

  background-position: initial;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  width: 100vw;
  height: 100%;
  background-image: ${props => props.backgroundImage};
  background-size: cover;
  padding: 0 5vmin;

  justify-content: flex-end;
  align-items: flex-end;
  position: fixed;
  box-sizing: border-box;

  @media only screen and (max-width: 1000px) {
    background-position: center;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContentContainer = styled.div`
  width: ${props => (props.isSignUpEnabled ? '50%' : '60%')};
  ${props => props.isSignUpEnabled && 'padding: 0 2% 0 2%;'}
  display: flex;
  margin: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 1000px) {
    width: 100%;
  }

  @media screen and (orientation: portrait) and (max-width: 460px) {
    width: 100%;

    div {
      margin-top: 1em;
    }
  }
`;

export const ContentContainerWithOffset = styled(ContentContainer)`
  ${props => props.isSignUpEnabled && 'padding: 0 2% 5rem 2%;'}
  @media screen and (orientation: portrait) and (max-width: 460px) {
    width: 100%;
    ${props => props.isSignUpEnabled && 'padding: 0 2% 0 2%;'}
    div {
      margin-top: 1em;
    }
  }
`;

export const FormContainer = styled.div`
  width: 50%;
  height: 100%;
  padding: 1vmin 0 1vmin 0;
  background-color: rgba(0, 0, 0, 0.48);
  border-radius: 0.5em;
`;

export const LeftSideContainer = styled.div`
  display: flex;
  width: 50%;
  height: 100%;
  flex-direction: column;
`;

export const LeftSideFormContainer = styled(FormContainer)`
  width: 100%;
`;

export const FormTitle = styled.p`
  font-size: 24px;
  font-weight: 600;
  color: ${theme.palette.common[1]};
  text-transform: uppercase;
`;

export const ClientLogo = styled.img`
  width: ${props => (props.isSignUpEnabled ? '20%' : '40%')};
`;

export const MainImage = styled.img`
  width: 90%;
`;

const MobilePageDescriptionContainer = css`
  padding: 0 4rem;
`;

export const PageDescriptionContainer = styled.div`
  font-size: 1.5rem;
  width: 100%;
  margin: auto;
  margin-top: 1.5rem;

  @media screen and (orientation: portrait) and (max-width: 460px) {
    margin-top: 1em;
  }
  ${({ isSignUpEnabled }) => isSignUpEnabled && !isTablet && isMobile && MobilePageDescriptionContainer}
`;

export const PageDescription = styled.p`
  font-size: 1.5rem;
  font-weight: 600;

  @media screen and (orientation: portrait) and (max-width: 460px) {
    font-size: 4.5rem;
  }
`;

export const PageBottomText = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 2rem;

  @media screen and (orientation: portrait) and (max-width: 460px) {
    font-size: 4.5rem;
  }
`;

export const LinkIconHolder = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1.5rem;

  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }

  @media screen and (orientation: portrait) and (max-width: 460px) {
    flex-direction: column;
  }
`;

export const LeftSideLinkIconHolder = styled(LinkIconHolder)`
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
`;

export const InnerDiv = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 1.5rem;
  }

  @media screen and (orientation: portrait) and (max-width: 460px) {
    margin-top: 2rem;
    width: 45em;
  }
`;

export const Badge = styled.img`
  width: 80%;

  @media screen and (orientation: portrait) and (max-width: 460px) {
    margin-top: 2rem;
    width: 45em;
  }
`;

export const TextContainer = styled.p`
  font-size: 20px;
  margin: 0px;
  padding-top: 5px;
  font-weight: 600;
`;

export const SignInButtonWrapper = styled.div`
  justify-content: center !important;
`;

export const SignInButtonImage = styled.img`
  cursor: pointer;
  width: 15em;
  height: 35%;

  ${({ theme, isGuestUserEnabled }) =>
    theme.screens.devices(['mobile-browser', 'mobile-standalone']) &&
    `
     margin-top: ${isGuestUserEnabled ? 0 : 1}rem;
     width: 21em;
  `}
`;

export const PlayAsGuestButtonWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  margin: auto;
  padding: ${pwaStyleAdapter(12, 'px', 1.7)} 0;
`;

